import React from 'react';
import { AssessmentsNativeBridgeProvider } from 'features/assessments/contexts/AssessmentsNativeBridgeContext';
import { UnauthenticatedAssessmentsGuard } from './UnauthenticatedAssessmentsGuard';

// Element for the unauthenticated assessments route: the guard (and the child routes it renders)
// sit inside the native bridge provider so the assessment can register with the bridge.
export const UnauthenticatedAssessmentsWrapper: React.FC = () => (
  <AssessmentsNativeBridgeProvider>
    <UnauthenticatedAssessmentsGuard />
  </AssessmentsNativeBridgeProvider>
);
